import { render, staticRenderFns } from "./HImgTitleSmall.vue?vue&type=template&id=428240a1&"
import script from "./HImgTitleSmall.vue?vue&type=script&lang=js&"
export * from "./HImgTitleSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428240a1')) {
      api.createRecord('428240a1', component.options)
    } else {
      api.reload('428240a1', component.options)
    }
    module.hot.accept("./HImgTitleSmall.vue?vue&type=template&id=428240a1&", function () {
      api.rerender('428240a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/post-components/h-img-title-small/HImgTitleSmall.vue"
export default component.exports